export default __webpack_public_path__ + "static/media/bkb3-gifts.e392bc31.png";